import { apiClients } from '@app/services/api/clients'
import { getApiClient } from '@app/utils/apiUtils'

export default (country, dpId, startMonth, endMonth) => {
  const client = getApiClient(apiClients, country)
  const url = `/1.0/dps/${dpId}/tiers?start_month=${startMonth}&end_month=${endMonth}`
  return client.get(url)
}
